const state = {
  // 场景构件列表视图类型：card | row
  componentListType: 'card',
}

const getters = {
  componentListType: (state) => {
    return ['card', 'row'].includes(state.componentListType) ? state.componentListType : 'card'
  },
}

const mutations = {
  setComponentListType(state, type) {
    if (['card', 'row'].includes(type)) {
      state.componentListType = type
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}
